import React, { useEffect, useState } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { Message } from '../../../utils/Message';
import { delay } from '../../../utils';

import { uploadVehicleImage } from '../../../service/api/Vehicle/apiVehicle';

const UploadVehicleImageModal = ({ vehicle, onClose, onRefresh }) => {
    const REACT_APP_API_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL;
    const [vehicleFiles, setVehicleFiles] = useState([]);
    const [licenseFiles, setLicenseFiles] = useState([]);
    const [vehiclePreviewImages, setVehiclePreviewImages] = useState([]);
    const [licensePreviewImages, setLicensePreviewImages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // 車輛圖片 FileChange
    const handleVehicleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        vehiclePreviewImages.forEach(img => URL.revokeObjectURL(img.url));
        const previews = files.map(file => ({ name: file.name, url: URL.createObjectURL(file) }));

        setVehiclePreviewImages(prev => [...previews]);
        setVehicleFiles(prev => [...prev, ...files]);
    };

    // 行照圖片 FileChange
    // const handleLicenseFileChange = (e) => {
    //     const files = Array.from(e.target.files);
    //     if (!files.length) return;
    //
    //     licensePreviewImages.forEach(img => URL.revokeObjectURL(img.url));
    //     const previews = files.map(file => ({ name: file.name, url: URL.createObjectURL(file) }));
    //
    //     setLicensePreviewImages(prev => [...previews]);
    //     setLicenseFiles(prev => [...prev, ...files]);
    // };

    // 初始化圖片預覽
    useEffect(() => {
        // 車輛圖片
        if (Array.isArray(vehicle?.imagePath)) {
            setVehiclePreviewImages(
                vehicle.imagePath.map(path => ({
                    url: `${REACT_APP_API_URL}/public${path}`
                }))
            );
        } else if (vehicle?.imagePath) {
            setVehiclePreviewImages([
                { url: `${REACT_APP_API_URL}/public${vehicle.imagePath}` }
            ]);
        }

        // 行照圖片
        // if (Array.isArray(vehicle?.licenseImagePath)) {
        //     setLicensePreviewImages(
        //         vehicle.licenseImagePath.map(path => ({
        //             url: `${REACT_APP_API_URL}/public${path}`
        //         }))
        //     );
        // } else if (vehicle?.licenseImagePath) {
        //     setLicensePreviewImages([
        //         { url: `${REACT_APP_API_URL}/public${vehicle.licenseImagePath}` }
        //     ]);
        // }
    }, [vehicle?.imagePath, vehicle?.licenseImagePath]);

    const handleUpload = async (files, type) => {
        if (files.length === 0) {
            Message('請選擇圖片', 'warning');
            return;
        }

        try {
            setIsLoading(true);
            const formData = new FormData();
            files.forEach(file => {
                formData.append('files', file);
            });

            const response = await uploadVehicleImage({ vehicleId: vehicle.id, formData }, type);

            if (response?.status === 200) {
                Message(`${type === 'vehicle' ? '車輛' : '行照'}圖片上傳成功`);
                await delay(1);
                if (type === 'vehicle') setVehicleFiles([]);
                else setLicenseFiles([]);
                onRefresh();
                onClose();
            }
        } catch (error) {
            console.error('上傳失敗:', error);
            Message('上傳失敗', 'error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <form>
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                    <div className="custom-modal-header">
                        <h5 className="modal-title">編輯圖片</h5>
                        <button className="btn-close" onClick={(e) => { onClose(); e.preventDefault(); }}></button>
                    </div>

                    <div className="custom-modal-body">
                        {/* 車輛照片 */}
                        <div className="input-group mb-3">
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                id={`upload-vehicle-${vehicle?.id || 'new'}`}
                                style={{ display: "none" }}
                                onChange={handleVehicleFileChange}
                            />
                            <label htmlFor={`upload-vehicle-${vehicle?.id || 'new'}`} className="btn btn-outline-secondary small-btn">
                                📷 選擇車輛照片
                            </label>
                        </div>

                        {vehiclePreviewImages.length > 0 && (
                            <div className="input-group mb-3">
                                <p className="fw-bold mb-2">車輛圖片：</p>
                                <div className="d-flex flex-wrap gap-2">
                                    {vehiclePreviewImages.map((img, index) => (
                                        <div key={index} className="preview-img-wrapper">
                                            <img src={img.url} alt={img.name} className="preview-img" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="input-group mb-3">
                            <button
                                type="button"
                                className="btn btn-outline-secondary small-btn"
                                onClick={() => handleUpload(vehicleFiles, 'vehicle')}
                                disabled={isLoading}
                            >
                                {isLoading ? '上傳中...' : '上傳照片'}
                            </button>
                        </div>

                        {/* 行照照片 */}
                        {/* <div className="image-preview-area mb-3">
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                id={`upload-license-${vehicle?.id || 'new'}`}
                                style={{ display: "none" }}
                                onChange={handleLicenseFileChange}
                            />
                            <label htmlFor={`upload-license-${vehicle?.id || 'new'}`} className="btn btn-outline-secondary small-btn">
                                📄 選擇行照照片
                            </label>
                        </div> */}

                        {/* {licensePreviewImages.length > 0 && (
                            <div className="input-group mb-3">
                                <p className="fw-bold mb-2">行照圖片：</p>
                                <div className="d-flex flex-wrap gap-2">
                                    {licensePreviewImages.map((img, index) => (
                                        <div key={index} className="preview-img-wrapper">
                                            <img src={img.url} alt={img.name} className="preview-img" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )} */}

                        {/* <div className="input-group mb-3">
                            <button
                                type="button"
                                className="btn btn-outline-secondary small-btn"
                                onClick={() => handleUpload(licenseFiles, 'license')}
                                disabled={isLoading}
                            >
                                {isLoading ? '上傳中...' : '上傳照片'}
                            </button>
                        </div> */}
                    </div>

                    <div className="custom-modal-footer">
                        <button className="btn btn-secondary" onClick={(e) => { onClose(); e.preventDefault(); }}>關閉</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export { UploadVehicleImageModal };
